<template>
  <div class="flex items-center justify-between py-1">
    <NuxtLink
      :to="localePath(`/betting-shop/${props.bettingShop.id}`)"
      class="focus:outline-none ring-0"
    >
      <div class="flex items-center gap-2">
        <img
          class="h-12"
          :src="props.bettingShop.logo"
          :alt="`logo of ${props.bettingShop.name}`"
        />
        <p class="text-neutral_50 font-bold text-[14px] leading-[150%]">
          {{ props.bettingShop.name }}
        </p>
      </div>
    </NuxtLink>
    <ButtonComponent
      type="text"
      text-size="text-[12px]"
      font-thickness="font-normal"
      :text="$t('gradeIt')"
      @click="
        router.push({
          path: localePath(`/betting-shop/${props.bettingShop.id}`),
          query: { review: true as any }
        })
      "
    />
  </div>
</template>
<script lang="ts" setup>
import type { BettingShop } from '~/interfaces';
const router = useRouter();
const localePath = useLocalePath();
const props = defineProps({
  bettingShop: {
    type: Object as PropType<BettingShop>,
    required: true
  }
});
</script>
